import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "face-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-triangle-exclamation" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!

  return (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
    class: "modal-something-wrong",
    acceptTheme: "primary",
    rejectTheme: "return",
    titleText: "QR Not Associated",
    subtitleText: "Please enter the trailer number manually.",
    acceptText: "Manual Trailer Entry",
    onAccept: _ctx.goToManualTrailerEntryFunction,
    rejectText: "",
    includeReturnDeepLink: true
  }, {
    "before-title": _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["onAccept"]))
}